// kfe-progress-line.js — horizontal progress bar.
//
// PORT TARGET: Classes/CustomViews/KFEProgressLine in iOS.
// value: 0..1.

import { KFEComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class KFEProgressLine extends KFEComponent {
  static props = ["value"];
  static styles = `
    :host { display: block; height: 8px; background: var(--kfe-border);
            border-radius: 999px; overflow: hidden; }
    .fill { height: 100%; background: var(--kfe-accent); transition: width 200ms ease; }
  `;
  render() {
    const v = Math.max(0, Math.min(1, Number(/** @type {any} */ (this).value) || 0));
    const fill = document.createElement("div");
    fill.className = "fill";
    fill.style.width = (v * 100) + "%";
    return html`${fill}`;
  }
}
